function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1-1h16v16H-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.667 3c0-.733-.6-1.333-1.334-1.333H1.667C.933 1.667.333 2.267.333 3v8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V3zm-1.334 0L7 6.333 1.667 3h10.666zm0 8H1.667V4.333L7 7.667l5.333-3.334V11z",
  fill: "#54585D",
  fillRule: "nonzero"
}))));